var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSumPolicy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50.02",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.68,7.31a25,25,0,1,0,0,35.38A25,25,0,0,0,42.68,7.31Zm-6.25,9a1.64,1.64,0,1,1-3.27,0h0V14.65H18.64L26.25,24a1.63,1.63,0,0,1,0,2.06l-7.61,9.31H33.16V33.7a1.64,1.64,0,0,1,3.27,0V37a1.63,1.63,0,0,1-1.64,1.62H15.2A1.61,1.61,0,0,1,13.57,37a1.63,1.63,0,0,1,.37-1L22.88,25,13.94,14.06a1.63,1.63,0,0,1,.23-2.3,1.61,1.61,0,0,1,1-.37H34.78A1.65,1.65,0,0,1,36.43,13V16.3Z",
    transform: "translate(0 0.01)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSumPolicy);
export default __webpack_public_path__ + "static/media/icon-sum-policy.db73b65000495b0caaf15d7e76aa27d8.svg";
export { ForwardRef as ReactComponent };